<template>
  <b-modal
    ref="modal"
    id="Modal"
    header-class="modal-confirm-header"
    body-class="modal-confirm-body"
    footer-class="modal-confirm-footer"
    @hide="cancelButton"
  >
    <div slot="modal-header" class="title-area modal-confirm">
      <font-awesome-icon
        :style="{ color: color }"
        class="icone-confirm-modal"
        :icon="icone ? icone : 'exclamation-circle'"
      />
      <h5 class="modal-title" id="ModalAdicionarTitulo">{{ labels.title }}</h5>
    </div>

    <div class="corpo-mensagem" v-html="labels.message"></div>

    <div class="confirm-modal-footer" slot="modal-footer">
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-padding"
        nome="Cancelar"
        icone="times"
        :click="cancelButton"
      />
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-padding"
        nome="Confirmar"
        icone="check"
        :click="confirmAction"
        cor="azul"
      />
    </div>
  </b-modal>
</template>

<script>
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";

export default {
  name: "ConfirmModal",
  components: {
    BotaoPadrao
  },
  props: {
    blShow: Boolean,
    icone: String,
    color: String,
    labels: {
      title: String,
      message: String
    },
    confirmAction: Function,
    cancelButton: Function
  },
  created() {
    document.addEventListener("keyup", this.handleKey);
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.handleKey);
  },
  mounted() {
    this.toggle(this.blShow);
  },
  methods: {
    handleKey(event) {
      if (event.key === "Escape" && this.blShow) {
        this.cancelButton();
      }
      if (event.key === "Enter" && this.blShow) {
        this.confirmAction();
      }
    },
    show: function() {
      this.$refs.modal.show();
    },
    hide: function() {
      this.$refs.modal.hide();
    },
    toggle: function(value) {
      if (value) {
        this.show();
      } else {
        this.hide();
      }
    }
  },
  watch: {
    blShow: function(value) {
      this.toggle(value);
    }
  }
};
</script>

<style lang="scss">
.modal-confirm-header {
  color: #007bff;
  background-color: var(--branco);
  border-bottom: 0;
  text-align: center;
}

.modal-confirm-header .modal-confirm {
  width: 100%;
}

.modal-confirm-header .modal-confirm button.close {
  position: absolute;
  top: 16px;
  right: 16px;
}

.modal-confirm-body {
  text-align: center;
  margin-bottom: 0;
}

.modal-confirm-footer .btn-secondary {
  background: #9e9e9e;
}

.modal-confirm-header .fa-times-circle {
  font-size: 70px;
  margin-bottom: 10px;
  margin-top: 10px;
}
#Modal .corpo-mensagem {
  word-wrap: break-word;
  display: flex;
  justify-content: center;
}
.icone-confirm-modal {
  font-size: 40px;
  margin: 5px 0;
}
.confirm-modal-footer {
  display: flex;
}
</style>
